<div>

    <div class="row clearfix">
        <div class="col-sm-12 gdpr-header-graphic-success"><span class="success-title" i18n>Successfully Completed</span></div>

        <div class="col-sm-12 gdpr-content-area">
            <p class="successtext">
                <span><img src="assets/Success_icon.svg" width="30" height="30" style="margin-right: 15px;" ></span>
                <span i18n>Your data preferences have been saved.</span>
            </p>
        </div>
    </div>
    <div class="col-sm-12 success-message">
        <h2 class="gdpr-h2 title gdpr-h2-margin p-0" i18n>Need assistance?</h2>
        <div class=" col-md-12 gdpr-para" style="padding: 0px 0px 50px 0px;">
            <span i18n>Didn't receive a verification code? Questions?</span><br>
            <span i18n>Send an email to the <a href="mailto:data.preferences@spglobal.com" class="text-danger">S&P Global Market Intelligence Support Team</a></span>
        </div>
    </div>
</div>
<div class="my-container">
    <ngx-loading></ngx-loading>
</div>